
<template>
  <div class='branch'
       v-if='item.SON'>
    <div class='entry'
         v-for='(child, i) in item.children'
         :key='i'>
      <span :class="`bg-${child.bg}`">{{name(child.ADDR)}}</span>
      <node :item='child' />
    </div>
  </div>
</template>

<script>
export default {
  name: 'node',
  props: {
    item: Object
  },
  methods: {
    name(ADDR) {
      if (ADDR < 10) return '00' + ADDR;
      else if (ADDR < 100) return '0' + ADDR;
      else return ADDR;
    }
  }
}
</script>
